import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { calendlyIframeSrc } from '../constants/calendly';
import './CalendlyEmbedModal.css';

function CalendlyEmbedModal({ isOpen, calendlyUrl, onClose }) {
  const [iframeReady, setIframeReady] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setIframeReady(false);
      return undefined;
    }
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  if (!isOpen || !calendlyUrl) return null;

  const iframeSrc = calendlyIframeSrc(calendlyUrl);

  const modal = (
    <div className="calendly-embed-overlay" onClick={onClose} role="presentation">
      <div
        className="calendly-embed-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Schedule a session"
      >
        <button type="button" className="calendly-embed-close" onClick={onClose} aria-label="Close scheduling">
          <X size={24} />
        </button>
        <div className="calendly-embed-frame-wrap">
          {!iframeReady && (
            <div className="calendly-embed-loading" aria-hidden="true">
              <div className="calendly-embed-loading-spinner" />
              <span>Loading scheduler…</span>
            </div>
          )}
          <iframe
            key={iframeSrc}
            title="Schedule with Bodyworks Training"
            src={iframeSrc}
            className={`calendly-embed-iframe${iframeReady ? ' calendly-embed-iframe--ready' : ''}`}
            frameBorder="0"
            allow="fullscreen"
            onLoad={() => setIframeReady(true)}
          />
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}

export default CalendlyEmbedModal;
